import React from "react";

const Portfolio=()=>{
    return(
        <div className="portfolio">
            Portfolio Page
        </div>
    )
}
export default Portfolio;